import axios from "../../api/axiosInctance";
import { guest } from "../../store/reducers/user/auth";
export const sleep = async (msec = 3000) => {
  return new Promise((resolve) => setTimeout(resolve, msec));
};
export const violSearchDataCall = async (data) => {
  try {
    // console.log(newFilter);
    const dataResponse = await axios
      .post("/vehicle/data", data)
      .then((res) => {
        // console.log(res.data);
        if (res.data.status.code === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return dataResponse;
  } catch (error) {
    // useDispatch(setViolationOffenderClear());
    return error;
    console.log(error);
  }
};
